<script setup>
import { ref } from 'vue';
import SearchableModel from '@/components/searchable-model/SearchableModel.vue';
import TourExponentCard from './TourExponentCard.vue';
import AddExponentToTour from './AddExponentToTour.vue';

const props = defineProps({
  baseFilters: {
    type: Object,
    required: true,
  },
  availableFilters: {
    type: Array,
    default: () => [],
  },
  tourId: {
    type: Number,
    required: true,
  },
  searchExponentUrl: {
    type: String,
    required: true,
  },
  attachedExponentIds: {
    type: Array,
    default: () => [],
  },
});

const listRef = ref(null);

const attachedIds = ref([...props.attachedExponentIds]);

const onAttached = (exponent) => {
  if (!attachedIds.value.includes(exponent.id)) {
    attachedIds.value.push(exponent.id);
  }
  listRef.value?.refresh();
};

const onDetached = (exponentId) => {
  attachedIds.value = attachedIds.value.filter((existing) => existing !== exponentId);
  listRef.value?.refresh();
};
</script>

<template>
  <SearchableModel
    ref="listRef"
    model-name="TourExponent"
    :base-filters="baseFilters"
    :available-filters="availableFilters"
    push-state
  >
    <template #header-actions>
      <AddExponentToTour
        :tour-id="tourId"
        :search-exponent-url="searchExponentUrl"
        :exponents-already-selected="attachedIds"
        @created="onAttached"
      />
    </template>
    <template #default="{ models }">
      <div class="tw:mt-4 tw:flex tw:flex-col tw:gap-3">
        <TourExponentCard
          v-for="exponent in models"
          :key="exponent.id"
          :exponent="exponent"
          :tour-id="tourId"
          @detached="onDetached"
        />
      </div>
    </template>
  </SearchableModel>
</template>
